import React, { useState, useEffect } from "react";
import { API } from "../../../../utils/api";
import ClientCard from "./ClientCard";

import "./ClientShowcase.css";

function ClientsComingSoon() {
  return (
    <div className="clients-empty">
      <div className="clients-empty-orb" aria-hidden="true"></div>
      <span className="clients-empty-icon" aria-hidden="true"></span>
      <h3 className="clients-empty-heading">
        Our client showcase is still coming together.
      </h3>
      <p className="clients-empty-body">
        We're still building out this section.  
        Partner with us, and you'll be the first voice others trust.
      </p>
      <a href="/quote" className="clients-empty-cta">
        Work with us →
      </a>
    </div>
  );
}

const ClientShowcase = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/clients`)
      .then((r) => r.json())
      .then((d) => setClients(d.clients || []))
      .catch(() => setClients([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="clients-section">
      <div className="clients-header">
        <h2>Our Clients</h2>

        <p>
          We were pleased to work with these companies, delivering custom
          software, mobile applications, digital solutions and creative services
          tailored to their needs. Hover over a logo to discover the services we
          provided, and click on the logos to explore the software solutions we
          have built.
        </p>
      </div>

      {loading && (
        <div className="clients-loading">
          <div className="clients-spinner"></div>
          <p>Loading clients…</p>
        </div>
      )}

      {!loading && clients.length === 0 && <ClientsComingSoon />}

      {!loading && clients.length > 0 && (
        <div className="clients-row">
          {clients.map((client) => (
            <ClientCard key={client.id} client={client} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ClientShowcase;
